import { l as v, u as c, m as b } from "./CSSMotionList.js";
import * as o from "react";
import { R as E } from "./CheckOutlined.js";
import { R as y } from "./CloseCircleFilled.js";
import { R as D } from "./CloseOutlined.js";
import { _ as N } from "./extends.js";
import { I as z } from "./AntdIcon.js";
import { R as C } from "./LoadingOutlined.js";
import { R as M } from "./SearchOutlined.js";
import { d as O } from "./warning.js";
const P = (e) => {
  const {
    multipleSelectItemHeight: l,
    paddingXXS: i,
    lineWidth: t,
    INTERNAL_FIXED_ITEM_MARGIN: n
  } = e, r = e.max(e.calc(i).sub(t).equal(), 0), s = e.max(e.calc(r).sub(n).equal(), 0);
  return {
    basePadding: r,
    containerPadding: s,
    itemHeight: c(l),
    itemLineHeight: c(e.calc(l).sub(e.calc(e.lineWidth).mul(2)).equal())
  };
}, _ = (e) => {
  const {
    multipleSelectItemHeight: l,
    selectHeight: i,
    lineWidth: t
  } = e;
  return e.calc(i).sub(l).div(2).sub(t).equal();
}, q = (e) => {
  const {
    componentCls: l,
    iconCls: i,
    borderRadiusSM: t,
    motionDurationSlow: n,
    paddingXS: r,
    multipleItemColorDisabled: s,
    multipleItemBorderColorDisabled: d,
    colorIcon: a,
    colorIconHover: h,
    INTERNAL_FIXED_ITEM_MARGIN: u
  } = e;
  return {
    /**
     * Do not merge `height` & `line-height` under style with `selection` & `search`, since chrome
     * may update to redesign with its align logic.
     */
    // =========================== Overflow ===========================
    [`${l}-selection-overflow`]: {
      position: "relative",
      display: "flex",
      flex: "auto",
      flexWrap: "wrap",
      maxWidth: "100%",
      "&-item": {
        flex: "none",
        alignSelf: "center",
        maxWidth: "100%",
        display: "inline-flex"
      },
      // ======================== Selections ==========================
      [`${l}-selection-item`]: {
        display: "flex",
        alignSelf: "center",
        flex: "none",
        boxSizing: "border-box",
        maxWidth: "100%",
        marginBlock: u,
        borderRadius: t,
        cursor: "default",
        transition: `font-size ${n}, line-height ${n}, height ${n}`,
        marginInlineEnd: e.calc(u).mul(2).equal(),
        paddingInlineStart: r,
        paddingInlineEnd: e.calc(r).div(2).equal(),
        [`${l}-disabled&`]: {
          color: s,
          borderColor: d,
          cursor: "not-allowed"
        },
        // It's ok not to do this, but 24px makes bottom narrow in view should adjust
        "&-content": {
          display: "inline-block",
          marginInlineEnd: e.calc(r).div(2).equal(),
          overflow: "hidden",
          whiteSpace: "pre",
          // fix whitespace wrapping. custom tags display all whitespace within.
          textOverflow: "ellipsis"
        },
        "&-remove": Object.assign(Object.assign({}, v()), {
          display: "inline-flex",
          alignItems: "center",
          color: a,
          fontWeight: "bold",
          fontSize: 10,
          lineHeight: "inherit",
          cursor: "pointer",
          [`> ${i}`]: {
            verticalAlign: "-0.2em"
          },
          "&:hover": {
            color: h
          }
        })
      }
    }
  };
}, W = (e, l) => {
  const {
    componentCls: i,
    INTERNAL_FIXED_ITEM_MARGIN: t
  } = e, n = `${i}-selection-overflow`, r = e.multipleSelectItemHeight, s = _(e), d = l ? `${i}-${l}` : "", a = P(e);
  return {
    [`${i}-multiple${d}`]: Object.assign(Object.assign({}, q(e)), {
      // ========================= Selector =========================
      [`${i}-selector`]: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "100%",
        // Multiple is little different that horizontal is follow the vertical
        paddingInline: a.basePadding,
        paddingBlock: a.containerPadding,
        borderRadius: e.borderRadius,
        [`${i}-disabled&`]: {
          background: e.multipleSelectorBgDisabled,
          cursor: "not-allowed"
        },
        "&:after": {
          display: "inline-block",
          width: 0,
          margin: `${c(t)} 0`,
          lineHeight: c(r),
          visibility: "hidden",
          content: '"\\a0"'
        }
      },
      // ======================== Selections ========================
      [`${i}-selection-item`]: {
        height: a.itemHeight,
        lineHeight: c(a.itemLineHeight)
      },
      // ========================== Wrap ===========================
      [`${i}-selection-wrap`]: {
        alignSelf: "flex-start",
        "&:after": {
          lineHeight: c(r),
          marginBlock: t
        }
      },
      // ========================== Input ==========================
      [`${i}-prefix`]: {
        marginInlineStart: e.calc(e.inputPaddingHorizontalBase).sub(a.basePadding).equal()
      },
      [`${n}-item + ${n}-item,
        ${i}-prefix + ${i}-selection-wrap
      `]: {
        [`${i}-selection-search`]: {
          marginInlineStart: 0
        },
        [`${i}-selection-placeholder`]: {
          insetInlineStart: 0
        }
      },
      // https://github.com/ant-design/ant-design/issues/44754
      // Same as `wrap:after`
      [`${n}-item-suffix`]: {
        minHeight: a.itemHeight,
        marginBlock: t
      },
      [`${i}-selection-search`]: {
        display: "inline-flex",
        position: "relative",
        maxWidth: "100%",
        marginInlineStart: e.calc(e.inputPaddingHorizontalBase).sub(s).equal(),
        "\n          &-input,\n          &-mirror\n        ": {
          height: r,
          fontFamily: e.fontFamily,
          lineHeight: c(r),
          transition: `all ${e.motionDurationSlow}`
        },
        "&-input": {
          width: "100%",
          minWidth: 4.1
          // fix search cursor missing
        },
        "&-mirror": {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          insetInlineEnd: "auto",
          zIndex: 999,
          whiteSpace: "pre",
          // fix whitespace wrapping caused width calculation bug
          visibility: "hidden"
        }
      },
      // ======================= Placeholder =======================
      [`${i}-selection-placeholder`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: e.calc(e.inputPaddingHorizontalBase).sub(a.basePadding).equal(),
        insetInlineEnd: e.inputPaddingHorizontalBase,
        transform: "translateY(-50%)",
        transition: `all ${e.motionDurationSlow}`
      }
    })
  };
};
function S(e, l) {
  const {
    componentCls: i
  } = e, t = l ? `${i}-${l}` : "", n = {
    [`${i}-multiple${t}`]: {
      fontSize: e.fontSize,
      // ========================= Selector =========================
      [`${i}-selector`]: {
        [`${i}-show-search&`]: {
          cursor: "text"
        }
      },
      [`
        &${i}-show-arrow ${i}-selector,
        &${i}-allow-clear ${i}-selector
      `]: {
        paddingInlineEnd: e.calc(e.fontSizeIcon).add(e.controlPaddingHorizontal).equal()
      }
    }
  };
  return [W(e, l), n];
}
const J = (e) => {
  const {
    componentCls: l
  } = e, i = b(e, {
    selectHeight: e.controlHeightSM,
    multipleSelectItemHeight: e.multipleItemHeightSM,
    borderRadius: e.borderRadiusSM,
    borderRadiusSM: e.borderRadiusXS
  }), t = b(e, {
    fontSize: e.fontSizeLG,
    selectHeight: e.controlHeightLG,
    multipleSelectItemHeight: e.multipleItemHeightLG,
    borderRadius: e.borderRadiusLG,
    borderRadiusSM: e.borderRadius
  });
  return [
    S(e),
    // ======================== Small ========================
    S(i, "sm"),
    // Padding
    {
      [`${l}-multiple${l}-sm`]: {
        [`${l}-selection-placeholder`]: {
          insetInline: e.calc(e.controlPaddingHorizontalSM).sub(e.lineWidth).equal()
        },
        // https://github.com/ant-design/ant-design/issues/29559
        [`${l}-selection-search`]: {
          marginInlineStart: 2
          // Magic Number
        }
      }
    },
    // ======================== Large ========================
    S(t, "lg")
  ];
};
var B = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, name: "down", theme: "outlined" }, L = function(l, i) {
  return /* @__PURE__ */ o.createElement(z, N({}, l, {
    ref: i,
    icon: B
  }));
}, w = /* @__PURE__ */ o.forwardRef(L);
process.env.NODE_ENV !== "production" && (w.displayName = "DownOutlined");
function K({
  suffixIcon: e,
  clearIcon: l,
  menuItemSelectedIcon: i,
  removeIcon: t,
  loading: n,
  multiple: r,
  hasFeedback: s,
  prefixCls: d,
  showSuffixIcon: a,
  feedbackIcon: h,
  showArrow: u,
  componentName: $
}) {
  process.env.NODE_ENV !== "production" && O($).deprecated(!l, "clearIcon", "allowClear={{ clearIcon: React.ReactNode }}");
  const R = l ?? /* @__PURE__ */ o.createElement(y, null), g = (m) => e === null && !s && !u ? null : /* @__PURE__ */ o.createElement(o.Fragment, null, a !== !1 && m, s && h);
  let f = null;
  if (e !== void 0)
    f = g(e);
  else if (n)
    f = g(/* @__PURE__ */ o.createElement(C, {
      spin: !0
    }));
  else {
    const m = `${d}-suffix`;
    f = ({
      open: x,
      showSearch: H
    }) => g(x && H ? /* @__PURE__ */ o.createElement(M, {
      className: m
    }) : /* @__PURE__ */ o.createElement(w, {
      className: m
    }));
  }
  let p = null;
  i !== void 0 ? p = i : r ? p = /* @__PURE__ */ o.createElement(E, null) : p = null;
  let I = null;
  return t !== void 0 ? I = t : I = /* @__PURE__ */ o.createElement(D, null), {
    clearIcon: R,
    suffixIcon: f,
    itemIcon: p,
    removeIcon: I
  };
}
export {
  w as R,
  P as a,
  J as b,
  q as g,
  K as u
};
